import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  formatDateTime,
  isValidDateValue,
} from '../../../shared/offer-domain/counter';

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

const pad = value => String(value).padStart(2, '0');

const formatRemaining = ms => {
  const days = Math.floor(ms / DAY);
  const hours = Math.floor((ms % DAY) / HOUR);
  const minutes = Math.floor((ms % HOUR) / MINUTE);
  if (days > 0) return `${days}d ${pad(hours)}h ${pad(minutes)}m`;
  if (hours > 0) return `${hours}h ${pad(minutes)}m`;
  return `${Math.max(minutes, 1)}m`;
};

const getTone = ms => {
  if (ms <= 0) return 'closed';
  if (ms < DAY) return 'urgent';
  if (ms < 3 * DAY) return 'soon';
  return 'ok';
};

/** Live "closes in" card for the offer submission deadline. */
const DeadlineCountdown = ({ deadline }) => {
  const [now, setNow] = useState(() => Date.now());
  const isValid = isValidDateValue(deadline);

  useEffect(() => {
    if (!isValid) return undefined;
    const timer = setInterval(() => setNow(Date.now()), 30 * 1000);
    return () => clearInterval(timer);
  }, [isValid]);

  if (!isValid) return null;

  const remaining = new Date(deadline).getTime() - now;
  const tone = getTone(remaining);
  const isClosed = tone === 'closed';

  return (
    <div className={`od-deadline od-deadline--${tone}`} role='timer'>
      <span className='od-deadline__icon' aria-hidden='true'>
        <i className={isClosed ? 'ri-lock-line' : 'ri-timer-flash-line'} />
      </span>
      <div style={{ minWidth: 0 }}>
        <span className='od-deadline__label'>
          {isClosed ? 'Submission closed' : 'Submission closes in'}
        </span>
        <span className='od-deadline__value'>
          {isClosed ? 'Closed' : formatRemaining(remaining)}
        </span>
        <span className='od-deadline__date'>
          {formatDateTime(deadline)} (Jakarta time)
        </span>
      </div>
    </div>
  );
};

DeadlineCountdown.propTypes = {
  deadline: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
};

export default DeadlineCountdown;
